export default "/images/vendor/flag-icons/flags/4x3/sh.svg?34a3e7b91929021ea39f623818bfafb6";